import React from 'react'

import { Autocomplete } from 'mui-rff'
import type { DashboardLayout } from '@edge/spark/io-dashboards'

interface Props {
    loading?: boolean
    dashboards: DashboardLayout[]
}

export const DashboardSelect: React.FC<Props> = ({ loading, dashboards }: Props) => {
    const sortedDashboards = dashboards.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, {
            sensitivity: 'base',
        }),
    )

    return (
        <Autocomplete
            required
            size="small"
            label="Dashboard"
            name="dashId"
            loading={loading}
            options={sortedDashboards}
            // String type regression
            // https://github.com/mui/material-ui/issues/23708
            getOptionLabel={(opt) => (typeof opt === 'string' ? opt : opt.name)}
            getOptionValue={({ id }) => id}
            textFieldProps={{ fullWidth: true }}
        />
    )
}

export default DashboardSelect
